import { mapGetters } from 'vuex'
import SiteSearchGroup from '@/components/search-group'
import journal from '@/api/journal'
import operation from '@/api/operation'
import Detail from './detail.dialog.vue'
import { specialApply } from '@/api/special'
import SendEmail from '@/views/editorial-office/manuscripts/dialog/send-email.dialog'
const columns = [
  {
    title: '',
    enTitle: 'Title',
    width: 400,
    dataIndex: 'titleText',
    slot: 'omis',
  },
  {
    title: '',
    enTitle: 'Applier',
    width: 200,
    dataIndex: 'Applier',
    slot: 'applier',
  },
  {
    title: '',
    enTitle: 'Status',
    width: 80,
    dataIndex: 'handle',
    slot: 'status',
  },
  {
    title: '',
    enTitle: 'Applied Time',
    width: 150,
    dataIndex: 'createTime',
    slot: 'time',
  },
  {
    title: '',
    enTitle: 'Processing Time',
    width: 150,
    dataIndex: 'dealTime',
    slot: 'time',
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 170,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions',
  },
]
export default {
  components: {
    SiteSearchGroup,
    Detail,
    SendEmail,
  },
  data() {
    return {
      columns,
      isVisable: false,
      showSendEmail: false,
      journalList: [],
      volumeList: [],
      issueList: [],
      dataSource: [],
      inputData: {},
      openSection: '',
      params: {
        handle: '',
        journalId: '',
      },
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true,
      },
      emailData: {},
      emailType: '',
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      domain: 'getDomain',
      country: 'getCountry',
      editorialBoard: 'getEditorialBoard',
      user: 'getUser',
    }),
  },
  async mounted() {
    await this.getJournalList()
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size,
      })
      const { list, pageIndex, pageSize, total } = await specialApply.get(data)
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex,
      })
    },
    async getJournalList() {
      this.journalList = await journal.userGet({ released: true })
      const flag = this.journalList.some((item) => {
        if (item.id === this.$route.query.journalId) {
          this.params.journalId = item.id
          return true
        }
      })
      this.journalList.unshift({
        name: 'All',
        id: '',
      })
      if (!flag) {
        this.params.journalId = this.journalList[0] && this.journalList[0].id
      }
      this.getList()
    },
    changeStatus(status) {
      this.params.handle = status
      this.getList()
    },
    edit(val) {
      this.$router.push(
        '/publishing/special-issue/application/' +
          val.id +
          '?journalId=' +
          this.params.journalId
      )
    },
    async accept(val) {
      this.$confirm({
        title: 'Are you sure you want to accept this application?',
        content:
          'Please be aware of once this application is accepted, the candidate will receive an notification email.',
        type: 'success',
      }).then(async () => {
        // this.sendEmail(val, 'approval_of_special_issue_application')
        await specialApply.accepted(val.id)
        await operation.add({
          authorityCode: 'WEBSITE.SPECIAL_ISSUES.APPLY.ACCEPT',
          type: 'ACCEPT',
          info: `Special Issue's Application - Accept: ${val.titleText} `,
          detail: `【Title】: ${val.titleText}`,
        })
        this.$message.success({
          title: 'Success',
          content: `The application for a special issue has been approved！`,
        })
        this.getList()
        // this.sendEmail(val)
      })
    },
    async reject(val) {
      this.$confirm({
        title: 'Are you sure you want to decline this application?',
        content:
          'Please be aware that once this application is declined, the candidate will receive an notification email.',
        type: 'danger',
        icon: 'iconDetails',
        confirmText: 'Reject',
      }).then(async () => {
        await specialApply.refused(val.id)
        await operation.add({
          authorityCode: 'WEBSITE.SPECIAL_ISSUES.APPLY.REFUSE',
          type: 'REFUSE',
          info: `Special Issue's Application - Refuse: ${val.titleText} `,
          detail: `【Title】: ${val.titleText}`,
        })
        this.$message.success({
          title: 'Success',
          content: `The Special issue has been refused!`,
        })
        this.getList()
      })
    },
    async detail(val) {
      if (val.handle === 'UNHANDLED') {
        this.edit(val)
      } else {
        this.isVisable = true
        this.inputData = await specialApply.query(val.id, {
          journalId: this.params.journalId,
        })
      }
    },
    handleClear() {
      this.params = {}
    },
    changeJournal() {
      this.getList()
    },
    confirm() {
      this.getList()
      this.isVisable = false
    },
    cancel() {
      this.isVisable = false
      this.showSendEmail = false
    },
    // 发送邮件
    sendEmail(val, type) {
      this.emailData = val
      this.emailType = type
      this.inputData = {
        applySpecialId: val.id,
        journalId: this.params.journalId,
      }
      this.showSendEmail = true
    },
    async send() {
      if (this.emailType === 'approval_of_special_issue_application') {
        await specialApply.accepted(this.emailData.id)
        this.$message.success({
          title: 'Success',
          content: `The application for a special issue has been approved！`,
        })
        this.getList()
      }
      this.cancel()
    },
  },
}
